import * as yup from 'yup';

export const PersonaColumnList = (isAdmin) => {
   return [
      {
         id: 'persona_id',
         dbname: 'id',
         label: 'id',
         visible: false,
         form: false,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'persona_tipo_identificacion_id',
         dbname: 'tipo_identificacion_id',
         label: 'tipo_identificacion_id',
         visible: false,
         form: true,
         filter: true,
         align: 'right',
         foreign: {
            table: 'tipo_identificacion',
            label: 'tipo_identificacion',
            dbname: 'tipo_identificaciondesc',
            type: 'small'
         }
      },
      {
         id: 'persona_documento',
         dbname: 'documento',
         label: 'documento',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'persona_nombre1',
         dbname: 'nombre1',
         label: 'nombre1',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'persona_nombre2',
         dbname: 'nombre2',
         label: 'nombre2',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'persona_apellido1',
         dbname: 'apellido1',
         label: 'apellido1',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'persona_apellido2',
         dbname: 'apellido2',
         label: 'apellido2',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'persona_email',
         dbname: 'email',
         label: 'email',
         visible: false,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'persona_telefono',
         dbname: 'telefono',
         label: 'telefono',
         visible: false,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'persona_direccion',
         dbname: 'direccion',
         label: 'direccion',
         visible: false,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'persona_fecha_creacion',
         dbname: 'fecha_creacion',
         label: 'fecha_creacion',
         visible: true,
         form: false,
         filter: false,
         type: 'datetime',
      },
      {
         id: 'persona_fecha_actualizacion',
         dbname: 'fecha_actualizacion',
         label: 'fecha_actualizacion',
         visible: false,
         form: false,
         filter: false,
         type: 'datetime',
      },

   ];
};

export const PersonaValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      nombre1: yup.string(),
      nombre2: yup.string().nullable(),
      apellido1: yup.string().nullable(),
      apellido2: yup.string().nullable(),
      tipo_identificacion_id: yup.number().nullable(),
      documento: yup.string(),
      email: yup.string().nullable(),
      telefono: yup.string().nullable(),
      direccion: yup.string().nullable(),
      fecha_creacion: yup.date().nullable(),
      fecha_actualizacion: yup.date().nullable(),

   });
};

export const PersonaFilterValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      nombre1: yup.string().nullable(),
      nombre2: yup.string().nullable(),
      apellido1: yup.string().nullable(),
      apellido2: yup.string().nullable(),
      tipo_identificacion_id: yup.number().nullable(),
      documento: yup.string().nullable(),
      email: yup.string().nullable(),
      telefono: yup.string().nullable(),
      direccion: yup.string().nullable(),
      fecha_creacion: yup.date().nullable(),
      fecha_actualizacion: yup.date().nullable(),

   });
};